/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { type AxiosInstance, type AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {
  /**
   * show loading status
   */
  loading?: boolean;
  /**
   * display error message
   */
  showError?: boolean;
  /**
   * data security, extended fields are encrypted using the specified algorithm
   */
  security?: Record<string, 'md5' | 'sha1' | 'aes' | 'des'>;
  /**
   * indicates whether Authorization credentials are required for the request
   * @default true
   */
  withAuthorization?: boolean;
}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
  /** only in axios interceptor config*/
  loading: boolean;
  showError: boolean;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = {
    loading: serviceOptions.loading,
    showError: serviceOptions.showError,
    ...options,
    method,
    url
  };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType
  };
  return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
export interface Response<T> {
  data: T | null;
  hasErrors: boolean;
  errors: Error[];
}

export interface Error {
  propertyName?: string;
  errorMessage?: string;
}

export interface AdvancedQueryPage<T> {
  items: T[];
  page: number;
  pageSize: number;
  pageCount: number;
  totalItemCount: number;
}

export interface OptionItemDto<T = number> {
  value: T;
  label: string;
  meta?: any;
}

export class ActionClassGetDto {
  /**  */
  'codeId'?: number;

  /**  */
  'actionCodeId'?: number;

  /**  */
  'canBeChanged'?: boolean;

  /**  */
  'class'?: string;

  /**  */
  'id'?: number;

  constructor(data: ActionClassGetDto = {}) {
    Object.assign(this, data);
  }
}

export class ActionClassSummaryDto {
  /**  */
  'id'?: number;

  /**  */
  'codeId'?: number;

  /**  */
  'actionCodeId'?: number;

  /**  */
  'canBeChanged'?: boolean;

  /**  */
  'actionCodeDescription'?: string;

  /**  */
  'levelOfServiceCodeDescription'?: string;

  /**  */
  'epicorClassDescription'?: string;

  /**  */
  'class'?: string;

  constructor(data: ActionClassSummaryDto = {}) {
    Object.assign(this, data);
  }
}

export class ActionCodeDetailDto {
  /**  */
  'sortOrder'?: number;

  /**  */
  'requireLot'?: boolean;

  /**  */
  'isDefault'?: boolean;

  /**  */
  'inactive'?: boolean;

  /**  */
  'requireDisposition'?: boolean;

  /**  */
  'description'?: string;

  /**  */
  'color': string;

  /**  */
  'id'?: number;

  /**  */
  'hasClassIdDefaults'?: boolean;

  constructor(data: ActionCodeDetailDto = {}) {
    Object.assign(this, data);
  }
}

export class ActionCodeDto {
  /**  */
  'sortOrder'?: number;

  /**  */
  'requireLot'?: boolean;

  /**  */
  'isDefault'?: boolean;

  /**  */
  'inactive'?: boolean;

  /**  */
  'requireDisposition'?: boolean;

  /**  */
  'description'?: string;

  /**  */
  'color': string;

  constructor(data: ActionCodeDto = {}) {
    Object.assign(this, data);
  }
}

export class ActionCodeGetDto {
  /**  */
  'sortOrder'?: number;

  /**  */
  'requireLot'?: boolean;

  /**  */
  'isDefault'?: boolean;

  /**  */
  'inactive'?: boolean;

  /**  */
  'requireDisposition'?: boolean;

  /**  */
  'description'?: string;

  /**  */
  'color': string;

  /**  */
  'id'?: number;

  constructor(data: ActionCodeGetDto = {}) {
    Object.assign(this, data);
  }
}

export class ActionCodeSummaryDto {
  /**  */
  'id'?: number;

  /**  */
  'sortOrder'?: number;

  /**  */
  'requireLot'?: boolean;

  /**  */
  'isDefault'?: boolean;

  /**  */
  'inactive'?: boolean;

  /**  */
  'requireDisposition'?: boolean;

  /**  */
  'hasClassIdDefaults'?: boolean;

  /**  */
  'description'?: string;

  /**  */
  'color'?: string;

  constructor(data: ActionCodeSummaryDto = {}) {
    Object.assign(this, data);
  }
}

export class AdvancedQueryColumnFilter {
  /**  */
  'fieldName': string;

  /**  */
  'fieldValue': string;

  /**  */
  'exactMatch'?: boolean;

  constructor(data: AdvancedQueryColumnFilter = {}) {
    Object.assign(this, data);
  }
}

export class AdvancedQueryColumnSort {
  /**  */
  'fieldName': string;

  /**  */
  'descending'?: boolean;

  constructor(data: AdvancedQueryColumnSort = {}) {
    Object.assign(this, data);
  }
}

export class AssignSerialNumberToRigRequest {
  /**  */
  'trackedSerialNumberId'?: number;

  /**  */
  'rigId'?: number;

  constructor(data: AssignSerialNumberToRigRequest = {}) {
    Object.assign(this, data);
  }
}

export class ClientNameGetDto {
  /**  */
  'value'?: string;

  /**  */
  'partnerSiteId'?: number;

  /**  */
  'id'?: number;

  constructor(data: ClientNameGetDto = {}) {
    Object.assign(this, data);
  }
}

export class CodeDetailDto {
  /**  */
  'codeClass': string;

  /**  */
  'description': string;

  /**  */
  'inactive': boolean;

  /**  */
  'sortOrder': number;

  /**  */
  'id'?: number;

  constructor(data: CodeDetailDto = {}) {
    Object.assign(this, data);
  }
}

export class CodeDto {
  /**  */
  'codeClass': string;

  /**  */
  'description': string;

  /**  */
  'inactive': boolean;

  /**  */
  'sortOrder': number;

  constructor(data: CodeDto = {}) {
    Object.assign(this, data);
  }
}

export class CodeGetDto {
  /**  */
  'codeClass': string;

  /**  */
  'description': string;

  /**  */
  'inactive': boolean;

  /**  */
  'sortOrder': number;

  /**  */
  'id'?: number;

  constructor(data: CodeGetDto = {}) {
    Object.assign(this, data);
  }
}

export class CosSelectionOptionDto {
  /**  */
  'label': string;

  /**  */
  'days'?: number;

  /**  */
  'sortOrder'?: number;

  /**  */
  'isActive'?: boolean;

  constructor(data: CosSelectionOptionDto = {} as any) {
    Object.assign(this, data);
  }
}

export class CosSelectionOptionGetDto {
  /**  */
  'id'?: number;

  /**  */
  'label': string;

  /**  */
  'days'?: number;

  /**  */
  'sortOrder'?: number;

  /**  */
  'isActive'?: boolean;

  constructor(data: CosSelectionOptionGetDto = {} as any) {
    Object.assign(this, data);
  }
}

export class CosSelectionOptionDetailDto {
  /**  */
  'id'?: number;

  /**  */
  'label': string;

  /**  */
  'days'?: number;

  /**  */
  'sortOrder'?: number;

  /**  */
  'isActive'?: boolean;

  constructor(data: CosSelectionOptionDetailDto = {} as any) {
    Object.assign(this, data);
  }
}

export class CreateCosSelectionOptionRequest {
  /**  */
  'label': string;

  /**  */
  'days'?: number;

  /**  */
  'sortOrder'?: number;

  /**  */
  'isActive'?: boolean;

  constructor(data: CreateCosSelectionOptionRequest = {} as any) {
    Object.assign(this, data);
  }
}

export class UpdateCosSelectionOptionRequest {
  /**  */
  'label': string;

  /**  */
  'days'?: number;

  /**  */
  'sortOrder'?: number;

  /**  */
  'isActive'?: boolean;

  constructor(data: UpdateCosSelectionOptionRequest = {} as any) {
    Object.assign(this, data);
  }
}

export class CreateActionClassRequest {
  /**  */
  'codeId'?: number;

  /**  */
  'actionCodeId'?: number;

  /**  */
  'canBeChanged'?: boolean;

  /**  */
  'class'?: string;

  constructor(data: CreateActionClassRequest = {}) {
    Object.assign(this, data);
  }
}

export class CreateActionCodeRequest {
  /**  */
  'sortOrder'?: number;

  /**  */
  'requireLot'?: boolean;

  /**  */
  'isDefault'?: boolean;

  /**  */
  'inactive'?: boolean;

  /**  */
  'requireDisposition'?: boolean;

  /**  */
  'description'?: string;

  /**  */
  'color': string;

  constructor(data: CreateActionCodeRequest = {}) {
    Object.assign(this, data);
  }
}

export class CreateClientNameRequest {
  /**  */
  'value'?: string;

  /**  */
  'partnerSiteId'?: number;

  constructor(data: CreateClientNameRequest = {}) {
    Object.assign(this, data);
  }
}

export class CreateCodeRequest {
  /**  */
  'codeClass': string;

  /**  */
  'description': string;

  /**  */
  'inactive': boolean;

  /**  */
  'sortOrder': number;

  constructor(data: CreateCodeRequest = {}) {
    Object.assign(this, data);
  }
}

export class CreateDocumentRequest {
  /**  */
  'jobId'?: number;

  /**  */
  'codeId'?: number;

  /**  */
  'reviewId'?: number;

  /**  */
  'name'?: string;

  /**  */
  'url': string;

  constructor(data: CreateDocumentRequest = {}) {
    Object.assign(this, data);
  }
}

export class CreateEmailEvaluationRequest {
  /**  */
  'partnerSiteId': number;

  /**  */
  'filterOnEnteredByUserId'?: number;

  /**  */
  'filterOnLevelOfServiceId'?: number;

  /**  */
  'email': string;

  /**  */
  'filterOnCanBeRepaired'?: string;

  /**  */
  'filterOnClientNamed'?: string;

  constructor(data: CreateEmailEvaluationRequest = {}) {
    Object.assign(this, data);
  }
}

export class CreateEmailLogRequest {
  /**  */
  'jobId'?: number;

  /**  */
  'status': string;

  /**  */
  'emailRecipients': string;

  constructor(data: CreateEmailLogRequest = {}) {
    Object.assign(this, data);
  }
}

export class CreateFieldRequest {
  /**  */
  'inactive'?: boolean;

  /**  */
  'sortOrder'?: number;

  /**  */
  'name': string;

  /**  */
  'type': string;

  /**  */
  'partnerSiteIds'?: number[];

  constructor(data: CreateFieldRequest = {}) {
    Object.assign(this, data);
  }
}

export class CreateJobRequest {
  /**  */
  'partnerSiteId': number;

  /**  */
  'serialNumber': string;

  /**  */
  'clientName': string;

  /**  */
  'jobType': string;

  /**  */
  'levelOfServiceId'?: number;

  /**  */
  'assetNumber'?: string;

  /**  */
  'memo'?: string;

  /**  */
  'notes'?: string;

  /**  */
  'reference1'?: string;

  /**  */
  'reference2'?: string;

  /**  */
  'oemCodeId'?: number;

  /**  */
  'partTypeCodeId'?: number;

  /**  */
  'upperConnectionCodeId'?: number;

  /**  */
  'middleConnectionCodeId'?: number;

  /**  */
  'lowerConnectionCodeId'?: number;

  /**  */
  'workingPressureCodeId'?: number;

  /**  */
  'serviceCodeId'?: number;

  /**  */
  'currentShShLength'?: number;

  /**  */
  'partDescription'?: string;

  constructor(data: CreateJobRequest = {}) {
    Object.assign(this, data);
  }
}

export class CreatePartnerSiteRequest {
  /**  */
  'sendEvaluationToActiveUser'?: boolean;

  /**  */
  'inactive'?: boolean;

  /**  */
  'sortOrder'?: number;

  /**  */
  'timeDifference'?: string;

  /**  */
  'arfNumber': string;

  /**  */
  'name': string;

  /**  */
  'signatureUrl': string;

  /**  */
  'signatoryName': string;

  /**  */
  'signatoryTitle': string;

  /**  */
  'logoUrl': string;

  /**  */
  'arfSealUrl': string;

  /**  */
  'address': string;

  /**  */
  'city': string;

  /**  */
  'state': string;

  /**  */
  'country': string;

  /**  */
  'zipCode': string;

  /**  */
  'serialNumberTrackingEnabled'?: boolean;

  /**  */
  'soldToValues'?: string;

  /**  */
  'allowCosDateOverride'?: boolean;

  /**  */
  'allowCosSelfSelection'?: boolean;

  /**  */
  'trackingReportEmails'?: string;

  /**  */
  'cosCutOffDaysOverride'?: number;

  /**  */
  'uecocExpirationDaysOverride'?: number;

  /**  */
  'reportFrequency'?: string;

  constructor(data: CreatePartnerSiteRequest = {}) {
    Object.assign(this, data);
  }
}

export class CreateRepairDocumentRequest {
  /**  */
  'name'?: string;

  /**  */
  'sortOrder'?: number;

  /**  */
  'description'?: string;

  /**  */
  'type'?: string;

  /**  */
  'url': string;

  /**  */
  'fileName': string;

  constructor(data: CreateRepairDocumentRequest = {}) {
    Object.assign(this, data);
  }
}

export class CreateReviewRequest {
  /**  */
  'jobId'?: number;

  /**  */
  'message': string;

  /**  */
  'status': string;

  /**  */
  'createDocumentRequest'?: CreateDocumentRequest;

  constructor(data: CreateReviewRequest = {}) {
    Object.assign(this, data);
  }
}

export class CreateRigRequest {
  /**  */
  'partnerSiteId'?: number;

  /**  */
  'name': string;

  /**  */
  'notificationEmails'?: string;

  constructor(data: CreateRigRequest = {}) {
    Object.assign(this, data);
  }
}

export class CreateRoutePatternRequest {
  /**  */
  'description': string;

  /**  */
  'pattern': string;

  constructor(data: CreateRoutePatternRequest = {}) {
    Object.assign(this, data);
  }
}

export class CreateUserRequest {
  /**  */
  'inactive'?: boolean;

  /**  */
  'emailAddress': string;

  /**  */
  'firstName': string;

  /**  */
  'lastName': string;

  /**  */
  'title'?: string;

  /**  */
  'role'?: string;

  /**  */
  'claims'?: string[];

  /**  */
  'partnerSiteIds'?: number[];

  constructor(data: CreateUserRequest = {}) {
    Object.assign(this, data);
  }
}

export class DashboardInfoDto {
  /**  */
  'evaluation'?: DashboardInfoRow;

  /**  */
  'archiving'?: DashboardInfoRow;

  /**  */
  'closedArchived'?: DashboardInfoRow;

  /**  */
  'customerSupportHours': string;

  /**  */
  'customerSupportEmail': string;

  /**  */
  'customerSupportPhone': string;

  constructor(data: DashboardInfoDto = {}) {
    Object.assign(this, data);
  }
}

export class DashboardInfoRow {
  /**  */
  'title': string;

  /**  */
  'jobCount'?: number;

  /**  */
  'dayCount'?: number;

  constructor(data: DashboardInfoRow = {}) {
    Object.assign(this, data);
  }
}

export class DocumentDetailDto {
  /**  */
  'jobId'?: number;

  /**  */
  'codeId'?: number;

  /**  */
  'reviewId'?: number;

  /**  */
  'name'?: string;

  /**  */
  'url': string;

  /**  */
  'id'?: number;

  /**  */
  'codeDescription'?: string;

  /**  */
  'createdByUserFirstName'?: string;

  /**  */
  'createdByUserLastName'?: string;

  /**  */
  'createdDate'?: Date;

  /**  */
  'isReadonly'?: boolean;

  constructor(data: DocumentDetailDto = {}) {
    Object.assign(this, data);
  }
}

export class DocumentGetDto {
  /**  */
  'jobId'?: number;

  /**  */
  'codeId'?: number;

  /**  */
  'reviewId'?: number;

  /**  */
  'name'?: string;

  /**  */
  'url': string;

  /**  */
  'id'?: number;

  constructor(data: DocumentGetDto = {}) {
    Object.assign(this, data);
  }
}

export class DocumentSummaryDto {
  /**  */
  'jobId'?: number;

  /**  */
  'jobSerialNumber'?: string;

  /**  */
  'jobPartNumber'?: string;

  /**  */
  'jobLevelOfServiceDescription'?: string;

  /**  */
  'createdDate'?: Date;

  /**  */
  'name'?: string;

  /**  */
  'url'?: string;

  /**  */
  'nextRecommendedCosServiceDate'?: Date;

  constructor(data: DocumentSummaryDto = {}) {
    Object.assign(this, data);
  }
}

export class EmailEvaluationDetailDto {
  /**  */
  'partnerSiteId': number;

  /**  */
  'filterOnEnteredByUserId'?: number;

  /**  */
  'filterOnLevelOfServiceId'?: number;

  /**  */
  'email': string;

  /**  */
  'filterOnCanBeRepaired'?: string;

  /**  */
  'filterOnClientNamed'?: string;

  /**  */
  'id'?: number;

  constructor(data: EmailEvaluationDetailDto = {}) {
    Object.assign(this, data);
  }
}

export class EmailEvaluationSummaryDto {
  /**  */
  'id'?: number;

  /**  */
  'partnerSiteId'?: number;

  /**  */
  'emailUserId'?: number;

  /**  */
  'filterOnEnteredByUserName'?: string;

  /**  */
  'filterOnLevelOfServiceDescription'?: string;

  /**  */
  'filterOnCanBeRepaired'?: string;

  /**  */
  'filterOnClientNamed'?: string;

  /**  */
  'partnerSiteArfNumber'?: string;

  /**  */
  'partnerSiteName'?: string;

  /**  */
  'email': string;

  constructor(data: EmailEvaluationSummaryDto = {}) {
    Object.assign(this, data);
  }
}

export class EmailLogDetailDto {
  /**  */
  'jobId'?: number;

  /**  */
  'status': string;

  /**  */
  'emailRecipients': string;

  /**  */
  'id'?: number;

  /**  */
  'createdDate'?: Date;

  /**  */
  'jobSerialNumber'?: string;

  /**  */
  'jobClientName'?: string;

  /**  */
  'jobCreatedByUserFirstName'?: string;

  /**  */
  'jobCreatedByUserLastName'?: string;

  /**  */
  'jobEvaluationIsRepairable'?: boolean;

  /**  */
  'jobLevelOfServiceDescription'?: string;

  constructor(data: EmailLogDetailDto = {}) {
    Object.assign(this, data);
  }
}

export class EmailLogGetDto {
  /**  */
  'jobId'?: number;

  /**  */
  'status': string;

  /**  */
  'emailRecipients': string;

  /**  */
  'id'?: number;

  /**  */
  'createdDate'?: Date;

  constructor(data: EmailLogGetDto = {}) {
    Object.assign(this, data);
  }
}

export class EmptyResponse {
  /**  */
  'hasErrors'?: boolean;

  /**  */
  'errors'?: Error[];

  constructor(data: EmptyResponse = {}) {
    Object.assign(this, data);
  }
}

export class Error {
  /**  */
  'propertyName'?: string;

  /**  */
  'errorMessage'?: string;

  constructor(data: Error = {}) {
    Object.assign(this, data);
  }
}

export class EvaluationDetailDto {
  /**  */
  'jobId'?: number;

  /**  */
  'isRepairable'?: boolean;

  /**  */
  'nonRepairableReason'?: string;

  /**  */
  'nonRepairableRemarks'?: string;

  /**  */
  'isCompleted'?: boolean;

  /**  */
  'completedDate'?: Date;

  /**  */
  'isQuoted'?: boolean;

  /**  */
  'isQuoteApproved'?: boolean;

  /**  */
  'quotedDate'?: Date;

  /**  */
  'quoteApprovedDisapprovedDate'?: Date;

  /**  */
  'quoteDisapprovalReason'?: string;

  /**  */
  'quoteReference'?: string;

  /**  */
  'quoteRemarks'?: string;

  /**  */
  'workPerformedSummary'?: string;

  /**  */
  'wasEvaluationFormSent'?: boolean;

  /**  */
  'id'?: number;

  /**  */
  'sentDate'?: Date;

  /**  */
  'quoteStatus'?: string;

  /**  */
  'jobStatus'?: string;

  constructor(data: EvaluationDetailDto = {}) {
    Object.assign(this, data);
  }
}

export class ExampleType {
  /**  */
  'someProperty'?: string;

  constructor(data: ExampleType = {}) {
    Object.assign(this, data);
  }
}

export class FieldDetailDto {
  /**  */
  'inactive'?: boolean;

  /**  */
  'sortOrder'?: number;

  /**  */
  'name': string;

  /**  */
  'type': string;

  /**  */
  'id'?: number;

  /**  */
  'partnerSiteIds': number[];

  constructor(data: FieldDetailDto = {}) {
    Object.assign(this, data);
  }
}

export class FieldGetDto {
  /**  */
  'inactive'?: boolean;

  /**  */
  'sortOrder'?: number;

  /**  */
  'name': string;

  /**  */
  'type': string;

  /**  */
  'id'?: number;

  constructor(data: FieldGetDto = {}) {
    Object.assign(this, data);
  }
}

export class FieldSummaryDto {
  /**  */
  'id'?: number;

  /**  */
  'inactive'?: boolean;

  /**  */
  'sortOrder'?: number;

  /**  */
  'name': string;

  /**  */
  'type': string;

  constructor(data: FieldSummaryDto = {}) {
    Object.assign(this, data);
  }
}

export class GenerateEvaluationFormPdfRequest {
  /**  */
  'sendToSales'?: boolean;

  constructor(data: GenerateEvaluationFormPdfRequest = {}) {
    Object.assign(this, data);
  }
}

export class GetDashboardInfoByUserRequest {
  constructor(data: GetDashboardInfoByUserRequest = {}) {
    Object.assign(this, data);
  }
}

export class ImportRigsCsvResult {
  /**  */
  'totalRows'?: number;

  /**  */
  'created'?: number;

  /**  */
  'skipped'?: number;

  /**  */
  'errors'?: string[];

  constructor(data: ImportRigsCsvResult = {}) {
    Object.assign(this, data);
  }
}

export class JobDetailDto {
  /**  */
  'partnerSiteId'?: number;

  /**  */
  'serialNumber'?: string;

  /**  */
  'partNumber'?: string;

  /**  */
  'productionDate'?: Date;

  /**  */
  'levelOfServiceId'?: number;

  /**  */
  'status'?: string;

  /**  */
  'assetNumber'?: string;

  /**  */
  'clientName'?: string;

  /**  */
  'reference1'?: string;

  /**  */
  'reference2'?: string;

  /**  */
  'memo'?: string;

  /**  */
  'notes'?: string;

  /**  */
  'partKitNumber'?: string;

  /**  */
  'partKitLotNumber'?: string;

  /**  */
  'canBeArchived'?: boolean;

  /**  */
  'dateClosed'?: Date;

  /**  */
  'certScrapReportIssuedDate'?: Date;

  /**  */
  'jobType'?: string;

  /**  */
  'cosServiceDate'?: Date;

  /**  */
  'oemCodeId'?: number;

  /**  */
  'partTypeCodeId'?: number;

  /**  */
  'upperConnectionCodeId'?: number;

  /**  */
  'middleConnectionCodeId'?: number;

  /**  */
  'lowerConnectionCodeId'?: number;

  /**  */
  'workingPressureCodeId'?: number;

  /**  */
  'serviceCodeId'?: number;

  /**  */
  'currentShShLength'?: number;

  /**  */
  'partDescription'?: string;

  /**  */
  'id'?: number;

  /**  */
  'revisionNumber'?: string;

  /**  */
  'evaluationQuoteStatus'?: string;

  /**  */
  'reviewStatus'?: string;

  /**  */
  'evaluationIsRepairable'?: boolean;

  /**  */
  'partnerSiteName'?: string;

  /**  */
  'levelOfServiceDescription'?: string;

  /**  */
  'serialNumberCreatedBy'?: string;

  /**  */
  'serialNumberModifiedBy'?: string;

  /**  */
  'createdByUser'?: string;

  /**  */
  'createdByUserId'?: number;

  /**  */
  'modifiedByUser'?: string;

  /**  */
  'serialNumberCreatedDate'?: Date;

  /**  */
  'serialNumberModifiedDate'?: Date;

  /**  */
  'createdDate'?: Date;

  /**  */
  'modifiedDate'?: Date;

  /**  */
  'partItems'?: PartItemDetailDto[];

  /**  */
  'lotsRequiredAmount'?: number;

  /**  */
  'lotsEnteredAmount'?: number;

  /**  */
  'ndeUploaded'?: boolean;

  /**  */
  'testChartUploaded'?: boolean;

  /**  */
  'isJobOwner'?: boolean;

  /**  */
  'isNewRevisionAvailable'?: boolean;

  /**  */
  'allowCosSelfSelection'?: boolean;

  constructor(data: JobDetailDto = {}) {
    Object.assign(this, data);
  }
}

export class JobField {
  /**  */
  'inactive'?: boolean;

  /**  */
  'sortOrder'?: number;

  /**  */
  'name': string;

  /**  */
  'type': string;

  /**  */
  'id'?: number;

  /**  */
  'value'?: any | null;

  constructor(data: JobField = {}) {
    Object.assign(this, data);
  }
}

export class JobGetDto {
  /**  */
  'partnerSiteId'?: number;

  /**  */
  'serialNumber'?: string;

  /**  */
  'partNumber'?: string;

  /**  */
  'productionDate'?: Date;

  /**  */
  'levelOfServiceId'?: number;

  /**  */
  'status'?: string;

  /**  */
  'assetNumber'?: string;

  /**  */
  'clientName'?: string;

  /**  */
  'reference1'?: string;

  /**  */
  'reference2'?: string;

  /**  */
  'memo'?: string;

  /**  */
  'notes'?: string;

  /**  */
  'partKitNumber'?: string;

  /**  */
  'partKitLotNumber'?: string;

  /**  */
  'canBeArchived'?: boolean;

  /**  */
  'dateClosed'?: Date;

  /**  */
  'certScrapReportIssuedDate'?: Date;

  /**  */
  'jobType'?: string;

  /**  */
  'cosServiceDate'?: Date;

  /**  */
  'oemCodeId'?: number;

  /**  */
  'partTypeCodeId'?: number;

  /**  */
  'upperConnectionCodeId'?: number;

  /**  */
  'middleConnectionCodeId'?: number;

  /**  */
  'lowerConnectionCodeId'?: number;

  /**  */
  'workingPressureCodeId'?: number;

  /**  */
  'serviceCodeId'?: number;

  /**  */
  'currentShShLength'?: number;

  /**  */
  'partDescription'?: string;

  /**  */
  'id'?: number;

  /**  */
  'revisionNumber'?: string;

  constructor(data: JobGetDto = {}) {
    Object.assign(this, data);
  }
}

export class JobSummaryDto {
  /**  */
  'id'?: number;

  /**  */
  'partnerSiteId'?: number;

  /**  */
  'partnerSiteArfNumber'?: string;

  /**  */
  'partnerSiteName'?: string;

  /**  */
  'levelOfServiceId'?: number;

  /**  */
  'serialNumber': string;

  /**  */
  'levelOfServiceDescription'?: string;

  /**  */
  'clientName'?: string;

  /**  */
  'assetNumber'?: string;

  /**  */
  'status'?: string;

  /**  */
  'evaluationIsRepairable'?: boolean;

  /**  */
  'reference1'?: string;

  /**  */
  'reference2'?: string;

  /**  */
  'memo'?: string;

  /**  */
  'notes'?: string;

  /**  */
  'createdDate'?: Date;

  /**  */
  'evaluationCompletedDate'?: Date;

  /**  */
  'evaluationQuoteStatus'?: string;

  /**  */
  'reviewStatus'?: string;

  /**  */
  'partNumber'?: string;

  /**  */
  'partDescription'?: string;

  /**  */
  'dateClosed'?: Date;

  /**  */
  'certScrapReportIssuedDate'?: Date;

  /**  */
  'jobType'?: string;

  /**  */
  'oemCodeId'?: number;

  /**  */
  'partTypeCodeId'?: number;

  /**  */
  'upperConnectionCodeId'?: number;

  /**  */
  'middleConnectionCodeId'?: number;

  /**  */
  'lowerConnectionCodeId'?: number;

  /**  */
  'workingPressureCodeId'?: number;

  /**  */
  'serviceCodeId'?: number;

  /**  */
  'oemCodeDescription'?: string;

  /**  */
  'partTypeCodeDescription'?: string;

  /**  */
  'upperConnectionCodeDescription'?: string;

  /**  */
  'middleConnectionCodeDescription'?: string;

  /**  */
  'lowerConnectionCodeDescription'?: string;

  /**  */
  'workingPressureCodeDescription'?: string;

  /**  */
  'serviceCodeDescription'?: string;

  /**  */
  'currentShShLength'?: number;

  constructor(data: JobSummaryDto = {}) {
    Object.assign(this, data);
  }
}

export class LogGroupNotesDto {
  /**  */
  'notes'?: string;

  /**  */
  'matchedPattern': string;

  /**  */
  'statusCode': number;

  /**  */
  'errorMessages'?: string;

  constructor(data: LogGroupNotesDto = {}) {
    Object.assign(this, data);
  }
}

export class LogGroupNotesGetDto {
  /**  */
  'notes'?: string;

  /**  */
  'matchedPattern': string;

  /**  */
  'statusCode': number;

  /**  */
  'errorMessages'?: string;

  /**  */
  'id'?: number;

  constructor(data: LogGroupNotesGetDto = {}) {
    Object.assign(this, data);
  }
}

export class LogSummaryDetailDto {
  /**  */
  'id'?: number;

  /**  */
  'timestamp'?: Date;

  /**  */
  'trace'?: string;

  /**  */
  'userId'?: string;

  /**  */
  'ipAddress'?: string;

  /**  */
  'route'?: string;

  /**  */
  'duration'?: string;

  /**  */
  'stack'?: string;

  /**  */
  'handledByUserId'?: number;

  /**  */
  'handledStatus'?: string;

  /**  */
  'notes'?: string;

  /**  */
  'markedAsHandledTimestamp'?: Date;

  constructor(data: LogSummaryDetailDto = {}) {
    Object.assign(this, data);
  }
}

export class LogSummaryGetDto {
  /**  */
  'timestamp'?: Date;

  /**  */
  'trace'?: string;

  /**  */
  'userId'?: string;

  /**  */
  'ipAddress'?: string;

  /**  */
  'route'?: string;

  /**  */
  'matchedPatterns'?: string;

  /**  */
  'statusCode'?: number;

  /**  */
  'duration'?: string;

  /**  */
  'errorMessages'?: string;

  /**  */
  'stack'?: string;

  /**  */
  'handledByUserId'?: number;

  /**  */
  'handledStatus'?: string;

  /**  */
  'notes'?: string;

  /**  */
  'important'?: boolean;

  /**  */
  'markedAsHandledTimestamp'?: Date;

  /**  */
  'logFileId'?: number;

  /**  */
  'id'?: number;

  constructor(data: LogSummaryGetDto = {}) {
    Object.assign(this, data);
  }
}

export class LogSummaryGroupListItem {
  /**  */
  'id'?: number;

  /**  */
  'createdByUserId'?: number;

  /**  */
  'modifiedByUserId'?: number;

  /**  */
  'deletedByUserId'?: number;

  /**  */
  'isDeleted'?: boolean;

  /**  */
  'createdDate'?: Date;

  /**  */
  'modifiedDate'?: Date;

  /**  */
  'deletedDate'?: Date;

  /**  */
  'statusCode'?: number;

  /**  */
  'matchedPattern'?: string;

  /**  */
  'occurrences'?: number;

  /**  */
  'errorMessages'?: string;

  /**  */
  'important'?: boolean;

  /**  */
  'hasUnhandledOccurrences'?: boolean;

  /**  */
  'firstOccurrenceTimestamp'?: Date;

  /**  */
  'lastOccurrenceTimestamp'?: Date;

  constructor(data: LogSummaryGroupListItem = {}) {
    Object.assign(this, data);
  }
}

export class LogSummaryListDto {
  /**  */
  'id'?: number;

  /**  */
  'matchedPatterns'?: string;

  /**  */
  'route'?: string;

  /**  */
  'timestamp'?: Date;

  /**  */
  'duration'?: string;

  /**  */
  'handledStatus'?: string;

  constructor(data: LogSummaryListDto = {}) {
    Object.assign(this, data);
  }
}

export class LotNumberGetDto {
  /**  */
  'value'?: string;

  /**  */
  'jobNumber'?: string;

  /**  */
  'partItemId'?: number;

  /**  */
  'id'?: number;

  constructor(data: LotNumberGetDto = {}) {
    Object.assign(this, data);
  }
}

export class OptionItemDto {
  /**  */
  'value': number;

  /**  */
  'label': string;

  /**  */
  'meta'?: any | null;

  constructor(data: OptionItemDto = {}) {
    Object.assign(this, data);
  }
}

export class PartItemDetailDto {
  /**  */
  'jobId'?: number;

  /**  */
  'canBeChangedOverride'?: boolean;

  /**  */
  'revisionOverride'?: string;

  /**  */
  'actionClassId'?: number;

  /**  */
  'actionCodeId'?: number;

  /**  */
  'dispositionCodeId'?: number;

  /**  */
  'partNumber'?: string;

  /**  */
  'partKitNumber'?: string;

  /**  */
  'description'?: string;

  /**  */
  'shortDescription'?: string;

  /**  */
  'class'?: string;

  /**  */
  'materialSequence'?: string;

  /**  */
  'qty'?: number;

  /**  */
  'actionQty'?: number;

  /**  */
  'nonMmLotNumber'?: string;

  /**  */
  'partNameCodeId'?: number;

  /**  */
  'id'?: number;

  /**  */
  'canBeChanged'?: boolean;

  /**  */
  'actionCode'?: ActionCodeDto;

  /**  */
  'partNameCode'?: CodeDto;

  /**  */
  'lotNumbers'?: LotNumberGetDto[];

  constructor(data: PartItemDetailDto = {}) {
    Object.assign(this, data);
  }
}

export class PartItemSummaryDto {
  /**  */
  'jobId'?: number;

  /**  */
  'partNumber'?: string;

  /**  */
  'description'?: string;

  /**  */
  'shortDescription'?: string;

  /**  */
  'class'?: string;

  /**  */
  'materialSequence'?: string;

  /**  */
  'qty'?: number;

  /**  */
  'action'?: string;

  /**  */
  'disposition'?: string;

  /**  */
  'canBeChanged'?: boolean;

  constructor(data: PartItemSummaryDto = {}) {
    Object.assign(this, data);
  }
}

export class PartnerSiteDetailDto {
  /**  */
  'id'?: number;

  /**  */
  'sortOrder'?: number;

  /**  */
  'sendEvaluationToActiveUser'?: boolean;

  /**  */
  'inactive'?: boolean;

  /**  */
  'timeDifference'?: string;

  /**  */
  'arfNumber': string;

  /**  */
  'name': string;

  /**  */
  'signatureUrl': string;

  /**  */
  'signatoryName': string;

  /**  */
  'signatoryTitle': string;

  /**  */
  'logoUrl': string;

  /**  */
  'arfSealUrl': string;

  /**  */
  'address': string;

  /**  */
  'city': string;

  /**  */
  'state': string;

  /**  */
  'country': string;

  /**  */
  'zipCode': string;

  /**  */
  'serialNumberTrackingEnabled'?: boolean;

  /**  */
  'soldToValues'?: string;

  /**  */
  'allowCosDateOverride'?: boolean;

  /**  */
  'allowCosSelfSelection'?: boolean;

  /**  */
  'trackingReportEmails'?: string;

  /**  */
  'cosCutOffDaysOverride'?: number;

  /**  */
  'uecocExpirationDaysOverride'?: number;

  /**  */
  'reportFrequency'?: string;

  constructor(data: PartnerSiteDetailDto = {}) {
    Object.assign(this, data);
  }
}

export class PartnerSiteGetDto {
  /**  */
  'sendEvaluationToActiveUser'?: boolean;

  /**  */
  'inactive'?: boolean;

  /**  */
  'sortOrder'?: number;

  /**  */
  'timeDifference'?: string;

  /**  */
  'arfNumber': string;

  /**  */
  'name': string;

  /**  */
  'signatureUrl': string;

  /**  */
  'signatoryName': string;

  /**  */
  'signatoryTitle': string;

  /**  */
  'logoUrl': string;

  /**  */
  'arfSealUrl': string;

  /**  */
  'address': string;

  /**  */
  'city': string;

  /**  */
  'state': string;

  /**  */
  'country': string;

  /**  */
  'zipCode': string;

  /**  */
  'serialNumberTrackingEnabled'?: boolean;

  /**  */
  'soldToValues'?: string;

  /**  */
  'allowCosDateOverride'?: boolean;

  /**  */
  'allowCosSelfSelection'?: boolean;

  /**  */
  'trackingReportEmails'?: string;

  /**  */
  'cosCutOffDaysOverride'?: number;

  /**  */
  'uecocExpirationDaysOverride'?: number;

  /**  */
  'reportFrequency'?: string;

  /**  */
  'id'?: number;

  constructor(data: PartnerSiteGetDto = {}) {
    Object.assign(this, data);
  }
}

export class QuickAddCodeOptionRequest {
  /**  */
  'codeClass': string;

  /**  */
  'description': string;

  /**  */
  'inactive': boolean;

  /**  */
  'sortOrder': number;

  constructor(data: QuickAddCodeOptionRequest = {}) {
    Object.assign(this, data);
  }
}

export class RepairDocumentDetailDto {
  /**  */
  'name'?: string;

  /**  */
  'sortOrder'?: number;

  /**  */
  'description'?: string;

  /**  */
  'type'?: string;

  /**  */
  'url': string;

  /**  */
  'fileName': string;

  /**  */
  'id'?: number;

  constructor(data: RepairDocumentDetailDto = {}) {
    Object.assign(this, data);
  }
}

export class RepairDocumentGetDto {
  /**  */
  'name'?: string;

  /**  */
  'sortOrder'?: number;

  /**  */
  'description'?: string;

  /**  */
  'type'?: string;

  /**  */
  'url': string;

  /**  */
  'fileName': string;

  /**  */
  'id'?: number;

  constructor(data: RepairDocumentGetDto = {}) {
    Object.assign(this, data);
  }
}

export class RepairDocumentSummaryDto {
  /**  */
  'id'?: number;

  /**  */
  'name'?: string;

  /**  */
  'sortOrder'?: number;

  /**  */
  'description'?: string;

  /**  */
  'type'?: string;

  /**  */
  'url'?: string;

  /**  */
  'fileName'?: string;

  /**  */
  'createdDate'?: Date;

  constructor(data: RepairDocumentSummaryDto = {}) {
    Object.assign(this, data);
  }
}

export class ReviewGetDto {
  /**  */
  'jobId'?: number;

  /**  */
  'message': string;

  /**  */
  'status': string;

  /**  */
  'id'?: number;

  constructor(data: ReviewGetDto = {}) {
    Object.assign(this, data);
  }
}

export class ReviewSummaryDto {
  /**  */
  'id'?: number;

  /**  */
  'jobId'?: number;

  /**  */
  'createdDate'?: Date;

  /**  */
  'createdByUserFirstName'?: string;

  /**  */
  'createdByUserLastName'?: string;

  /**  */
  'partnerSite'?: string;

  /**  */
  'jobPartNumber'?: string;

  /**  */
  'jobSerialNumber'?: string;

  /**  */
  'levelOfService'?: string;

  /**  */
  'jobStatus'?: string;

  /**  */
  'isRepairable'?: boolean;

  /**  */
  'message': string;

  /**  */
  'status': string;

  /**  */
  'documents'?: DocumentGetDto[];

  constructor(data: ReviewSummaryDto = {}) {
    Object.assign(this, data);
  }
}

export class RigGetDto {
  /**  */
  'partnerSiteId'?: number;

  /**  */
  'name': string;

  /**  */
  'notificationEmails'?: string;

  /**  */
  'id'?: number;

  /**  */
  'partnerSiteName'?: string;

  constructor(data: RigGetDto = {}) {
    Object.assign(this, data);
  }
}

export class RoutePatternDto {
  /**  */
  'description': string;

  /**  */
  'pattern': string;

  constructor(data: RoutePatternDto = {}) {
    Object.assign(this, data);
  }
}

export class RoutePatternGetDto {
  /**  */
  'description': string;

  /**  */
  'pattern': string;

  /**  */
  'id'?: number;

  constructor(data: RoutePatternGetDto = {}) {
    Object.assign(this, data);
  }
}

export class SettingSummaryDto {
  /**  */
  'value': string;

  /**  */
  'id'?: number;

  /**  */
  'key': string;

  /**  */
  'type': string;

  /**  */
  'enum'?: string;

  constructor(data: SettingSummaryDto = {}) {
    Object.assign(this, data);
  }
}

export class SnEnabledPartnerSiteDto {
  /**  */
  'id'?: number;

  /**  */
  'name': string;

  /**  */
  'arfNumber': string;

  /**  */
  'rigCount'?: number;

  /**  */
  'trackedSerialNumberCount'?: number;

  constructor(data: SnEnabledPartnerSiteDto = {}) {
    Object.assign(this, data);
  }
}

export class SyncSerialNumbersFromEpicorRequest {
  /**  */
  'partnerSiteId'?: number;

  constructor(data: SyncSerialNumbersFromEpicorRequest = {}) {
    Object.assign(this, data);
  }
}

export class SyncSerialNumbersResult {
  /**  */
  'totalFetched'?: number;

  /**  */
  'newRecords'?: number;

  /**  */
  'updatedRecords'?: number;

  /**  */
  'unchangedRecords'?: number;

  constructor(data: SyncSerialNumbersResult = {}) {
    Object.assign(this, data);
  }
}

export class TrackedSerialNumberAuditDisplayDto {
  /**  */
  'trackedSerialNumberId'?: number;

  /**  */
  'fieldName': string;

  /**  */
  'oldValue'?: string;

  /**  */
  'newValue'?: string;

  /**  */
  'changeType': string;

  /**  */
  'createdByUserId'?: number;

  /**  */
  'createdDate'?: Date;

  /**  */
  'id'?: number;

  /**  */
  'createdByUserName'?: string;

  constructor(data: TrackedSerialNumberAuditDisplayDto = {}) {
    Object.assign(this, data);
  }
}

export class TrackedSerialNumberGetDto {
  /**  */
  'partnerSiteId'?: number;

  /**  */
  'rigId'?: number;

  /**  */
  'serialNumber': string;

  /**  */
  'partNumber'?: string;

  /**  */
  'partDescription'?: string;

  /**  */
  'productionDate'?: Date;

  /**  */
  'notes'?: string;

  /**  */
  'cosDateOverride'?: Date;

  /**  */
  'lastSyncDate'?: Date;

  /**  */
  'soldTo'?: string;

  /**  */
  'serviceStatus'?: string;

  /**  */
  'id'?: number;

  /**  */
  'partnerSiteName'?: string;

  /**  */
  'rigName'?: string;

  /**  */
  'inactiveReason'?: string;

  constructor(data: TrackedSerialNumberGetDto = {}) {
    Object.assign(this, data);
  }
}

export class TrackedSerialNumberListingDto {
  /**  */
  'id': number;

  /**  */
  'partnerSiteId': number;

  /**  */
  'rigId'?: number;

  /**  */
  'serialNumber'?: string;

  /**  */
  'partNumber'?: string;

  /**  */
  'partDescription'?: string;

  /**  */
  'productionDate'?: Date;

  /**  */
  'notes'?: string;

  /**  */
  'cosDateOverride'?: Date;

  /**  */
  'lastSyncDate'?: Date;

  /**  */
  'soldTo'?: string;

  /**  */
  'partnerSiteName'?: string;

  /**  */
  'rigName'?: string;

  /**  */
  'serviceStatus'?: string;

  /**  */
  'serviceStatusColor'?: string;

  /**  */
  'certificationStatus'?: string;

  /**  */
  'lastServiceDate'?: Date;

  /**  */
  'lastServiceType'?: string;

  /**  */
  'nextRecommendedCosService'?: Date;

  /**  */
  'nextRequiredUecoc'?: Date;

  /**  */
  'inactiveReason'?: string;

  constructor(data: TrackedSerialNumberListingDto = {}) {
    Object.assign(this, data);
  }
}

export class UpdateActionClassRequest {
  /**  */
  'codeId'?: number;

  /**  */
  'actionCodeId'?: number;

  /**  */
  'canBeChanged'?: boolean;

  /**  */
  'class'?: string;

  constructor(data: UpdateActionClassRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateActionCodeRequest {
  /**  */
  'sortOrder'?: number;

  /**  */
  'requireLot'?: boolean;

  /**  */
  'isDefault'?: boolean;

  /**  */
  'inactive'?: boolean;

  /**  */
  'requireDisposition'?: boolean;

  /**  */
  'description'?: string;

  /**  */
  'color': string;

  constructor(data: UpdateActionCodeRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateClientNameRequest {
  /**  */
  'value'?: string;

  /**  */
  'partnerSiteId'?: number;

  constructor(data: UpdateClientNameRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateCodeRequest {
  /**  */
  'codeClass': string;

  /**  */
  'description': string;

  /**  */
  'inactive': boolean;

  /**  */
  'sortOrder': number;

  constructor(data: UpdateCodeRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateDocumentRequest {
  /**  */
  'jobId'?: number;

  /**  */
  'codeId'?: number;

  /**  */
  'reviewId'?: number;

  /**  */
  'name'?: string;

  /**  */
  'url': string;

  constructor(data: UpdateDocumentRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateEmailEvaluationRequest {
  /**  */
  'partnerSiteId': number;

  /**  */
  'filterOnEnteredByUserId'?: number;

  /**  */
  'filterOnLevelOfServiceId'?: number;

  /**  */
  'email': string;

  /**  */
  'filterOnCanBeRepaired'?: string;

  /**  */
  'filterOnClientNamed'?: string;

  constructor(data: UpdateEmailEvaluationRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateEmailLogRequest {
  /**  */
  'jobId'?: number;

  /**  */
  'status': string;

  /**  */
  'emailRecipients': string;

  constructor(data: UpdateEmailLogRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateEvaluationRequest {
  /**  */
  'jobId'?: number;

  /**  */
  'isRepairable'?: boolean;

  /**  */
  'nonRepairableReason'?: string;

  /**  */
  'nonRepairableRemarks'?: string;

  /**  */
  'isCompleted'?: boolean;

  /**  */
  'completedDate'?: Date;

  /**  */
  'isQuoted'?: boolean;

  /**  */
  'isQuoteApproved'?: boolean;

  /**  */
  'quotedDate'?: Date;

  /**  */
  'quoteApprovedDisapprovedDate'?: Date;

  /**  */
  'quoteDisapprovalReason'?: string;

  /**  */
  'quoteReference'?: string;

  /**  */
  'quoteRemarks'?: string;

  /**  */
  'workPerformedSummary'?: string;

  /**  */
  'wasEvaluationFormSent'?: boolean;

  constructor(data: UpdateEvaluationRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateFieldRequest {
  /**  */
  'inactive'?: boolean;

  /**  */
  'sortOrder'?: number;

  /**  */
  'name': string;

  /**  */
  'type': string;

  /**  */
  'partnerSiteIds'?: number[];

  constructor(data: UpdateFieldRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateJobRequest {
  /**  */
  'partnerSiteId'?: number;

  /**  */
  'serialNumber'?: string;

  /**  */
  'partNumber'?: string;

  /**  */
  'productionDate'?: Date;

  /**  */
  'levelOfServiceId'?: number;

  /**  */
  'status'?: string;

  /**  */
  'assetNumber'?: string;

  /**  */
  'clientName'?: string;

  /**  */
  'reference1'?: string;

  /**  */
  'reference2'?: string;

  /**  */
  'memo'?: string;

  /**  */
  'notes'?: string;

  /**  */
  'partKitNumber'?: string;

  /**  */
  'partKitLotNumber'?: string;

  /**  */
  'canBeArchived'?: boolean;

  /**  */
  'dateClosed'?: Date;

  /**  */
  'certScrapReportIssuedDate'?: Date;

  /**  */
  'jobType'?: string;

  /**  */
  'cosServiceDate'?: Date;

  /**  */
  'oemCodeId'?: number;

  /**  */
  'partTypeCodeId'?: number;

  /**  */
  'upperConnectionCodeId'?: number;

  /**  */
  'middleConnectionCodeId'?: number;

  /**  */
  'lowerConnectionCodeId'?: number;

  /**  */
  'workingPressureCodeId'?: number;

  /**  */
  'serviceCodeId'?: number;

  /**  */
  'currentShShLength'?: number;

  /**  */
  'partDescription'?: string;

  constructor(data: UpdateJobRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdatePartKitLotNumberRequest {
  /**  */
  'partKitLotNumber'?: string;

  constructor(data: UpdatePartKitLotNumberRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdatePartKitRequest {
  /**  */
  'partKitNumber'?: string;

  constructor(data: UpdatePartKitRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdatePartnerSiteRequest {
  /**  */
  'sendEvaluationToActiveUser'?: boolean;

  /**  */
  'inactive'?: boolean;

  /**  */
  'sortOrder'?: number;

  /**  */
  'timeDifference'?: string;

  /**  */
  'arfNumber': string;

  /**  */
  'name': string;

  /**  */
  'signatureUrl': string;

  /**  */
  'signatoryName': string;

  /**  */
  'signatoryTitle': string;

  /**  */
  'logoUrl': string;

  /**  */
  'arfSealUrl': string;

  /**  */
  'address': string;

  /**  */
  'city': string;

  /**  */
  'state': string;

  /**  */
  'country': string;

  /**  */
  'zipCode': string;

  /**  */
  'serialNumberTrackingEnabled'?: boolean;

  /**  */
  'soldToValues'?: string;

  /**  */
  'allowCosDateOverride'?: boolean;

  /**  */
  'allowCosSelfSelection'?: boolean;

  /**  */
  'trackingReportEmails'?: string;

  /**  */
  'cosCutOffDaysOverride'?: number;

  /**  */
  'uecocExpirationDaysOverride'?: number;

  /**  */
  'reportFrequency'?: string;

  constructor(data: UpdatePartnerSiteRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdatePartsListRequest {
  /**  */
  'partItems'?: PartItemDetailDto[];

  constructor(data: UpdatePartsListRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateRepairDocumentRequest {
  /**  */
  'name'?: string;

  /**  */
  'sortOrder'?: number;

  /**  */
  'description'?: string;

  /**  */
  'type'?: string;

  /**  */
  'url': string;

  /**  */
  'fileName': string;

  constructor(data: UpdateRepairDocumentRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateRepairServicePerformedRequest {
  /**  */
  'jobFields'?: JobField[];

  constructor(data: UpdateRepairServicePerformedRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateReplacedPartsRequest {
  /**  */
  'partItems'?: PartItemDetailDto[];

  constructor(data: UpdateReplacedPartsRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateReviewRequest {
  /**  */
  'jobId'?: number;

  /**  */
  'message': string;

  /**  */
  'status': string;

  constructor(data: UpdateReviewRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateRigRequest {
  /**  */
  'partnerSiteId'?: number;

  /**  */
  'name': string;

  /**  */
  'notificationEmails'?: string;

  constructor(data: UpdateRigRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateRoutePatternRequest {
  /**  */
  'description': string;

  /**  */
  'pattern': string;

  constructor(data: UpdateRoutePatternRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateSettingRequest {
  /**  */
  'value': string;

  constructor(data: UpdateSettingRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateTrackedSerialNumberRequest {
  /**  */
  'notes'?: string;

  /**  */
  'cosDateOverride'?: Date;

  /**  */
  'serviceStatus'?: string;

  /**  */
  'inactiveReason'?: string;

  constructor(data: UpdateTrackedSerialNumberRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateUserPasswordRequest {
  /**  */
  'confirmNewPassword': string;

  /**  */
  'currentPassword': string;

  /**  */
  'newPassword': string;

  constructor(data: UpdateUserPasswordRequest = {}) {
    Object.assign(this, data);
  }
}

export class UpdateUserRequest {
  /**  */
  'inactive'?: boolean;

  /**  */
  'emailAddress': string;

  /**  */
  'firstName': string;

  /**  */
  'lastName': string;

  /**  */
  'title'?: string;

  /**  */
  'role'?: string;

  /**  */
  'claims'?: string[];

  /**  */
  'partnerSiteIds'?: number[];

  constructor(data: UpdateUserRequest = {}) {
    Object.assign(this, data);
  }
}

export class UploadFileResponse {
  /**  */
  'uri': string;

  constructor(data: UploadFileResponse = {}) {
    Object.assign(this, data);
  }
}

export class UserDetailDto {
  /**  */
  'inactive'?: boolean;

  /**  */
  'emailAddress': string;

  /**  */
  'firstName': string;

  /**  */
  'lastName': string;

  /**  */
  'title'?: string;

  /**  */
  'role'?: string;

  /**  */
  'id'?: number;

  /**  */
  'claims'?: string[];

  /**  */
  'partnerSites'?: PartnerSiteDetailDto[];

  constructor(data: UserDetailDto = {}) {
    Object.assign(this, data);
  }
}

export class UserGetDto {
  /**  */
  'inactive'?: boolean;

  /**  */
  'emailAddress': string;

  /**  */
  'firstName': string;

  /**  */
  'lastName': string;

  /**  */
  'title'?: string;

  /**  */
  'role'?: string;

  /**  */
  'id'?: number;

  constructor(data: UserGetDto = {}) {
    Object.assign(this, data);
  }
}

export class UserSummaryDto {
  /**  */
  'id'?: number;

  /**  */
  'inactive'?: boolean;

  /**  */
  'emailAddress'?: string;

  /**  */
  'title'?: string;

  /**  */
  'firstName'?: string;

  /**  */
  'lastName'?: string;

  /**  */
  'role'?: string;

  /**  */
  'partnerSiteNames'?: string[];

  constructor(data: UserSummaryDto = {}) {
    Object.assign(this, data);
  }
}
